import React, { useState, Component } from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { ArrowRight, CheckCircle, Copy, Check, MessageSquare, Smartphone, Share2, FileText, Sparkles, Zap, Brain, RefreshCw, AlertCircle, UserPlus, History, ArrowUpRight, Star, CheckCircle2, Gift } from 'lucide-react';
import { Link } from 'react-router-dom';
export function TextLandingPage() {
  const [copied, setCopied] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);
  const phoneNumber = '(774) 472-7423';
  const smsHref = `sms:+1${phoneNumber.replace(/\D/g, '')}?body=Hi%20ScribeTok!%20I%20want%20to%20transcribe%20a%20video.`;
  const shareMessage = `✨ Get readable TikToks in seconds! Text any TikTok link to ${phoneNumber} and get an instant transcript. No app needed. Try it: https://scribetok.com/text`;
  const handleCopyNumber = () => {
    navigator.clipboard.writeText(phoneNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'ScribeTok - Text to Transcript',
          text: shareMessage,
          url: window.location.href
        });
      } catch (error) {
        console.log('Error sharing:', error);
        setShareOpen(!shareOpen);
      }
    } else {
      setShareOpen(!shareOpen);
    }
  };
  const handleCopyShareLink = () => {
    navigator.clipboard.writeText(shareMessage);
    setShareOpen(false);
  };
  return <div className="min-h-screen w-full bg-background flex flex-col items-center justify-center p-4 sm:p-6 overflow-x-hidden" data-id="element-1320">
      <div className="max-w-md w-full mx-auto text-center" data-id="element-1321">
        {/* Logo */}
        <div className="flex justify-center mb-6" data-id="element-1322">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6tsscMEhsZ3L4JwT2r374e/ScribeTok-logo.png" alt="ScribeTok Logo" className="h-14 w-auto" data-id="element-1323" />
        </div>
        <div className="mb-2" data-id="element-1324">
          <span className="inline-block bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-medium" data-id="element-1325">
            Text → Read → Share
          </span>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold mb-3 animate-slide-down" data-id="element-1326">
          The Reading Mode{' '}
          <span className="text-primary" data-id="element-1327">TikTok Never Gave You</span>
        </h1>
        <p className="text-lg text-muted-foreground mb-8 animate-slide-down" style={{
        animationDelay: '100ms'
      }} data-id="element-1328">
          When you'd rather read than watch. Get the content without the endless
          scrolling.
        </p>
        <Card className="mb-8 animate-scale" style={{
        animationDelay: '200ms'
      }} data-id="element-1329">
          <CardContent className="p-6 flex flex-col items-center" data-id="element-1330">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4" data-id="element-1331">
              <Smartphone size={28} className="text-primary" data-id="element-1332" />
            </div>
            <h2 className="text-xl font-medium mb-2" data-id="element-1333">Text this number</h2>
            <p className="text-sm text-muted-foreground mb-4" data-id="element-1334">
              One text = instant transcript 🪄
            </p>
            <div className="flex items-center gap-2 px-4 py-2 bg-secondary rounded-full cursor-pointer mb-4 hover:bg-secondary/80 transition-colors" onClick={handleCopyNumber} data-id="element-1335">
              <span className="font-medium" data-id="element-1336">{phoneNumber}</span>
              {copied ? <Check size={16} className="text-green-500" data-id="element-1337" /> : <Copy size={16} data-id="element-1338" />}
            </div>
            <div className="text-sm text-muted-foreground mb-4 px-2 py-1 bg-secondary/50 rounded-lg border border-border/50" data-id="element-1339">
              <p className="text-center" data-id="element-1340">
                By texting us, you consent to receive automated reply messages.
                Message & data rates may apply. Reply STOP to unsubscribe.
              </p>
            </div>
            <a href={smsHref} className="block mb-4 relative group mx-auto flex flex-col items-center" data-id="element-1341">
              <div className="absolute -inset-2 bg-primary/5 rounded-2xl scale-0 group-hover:scale-100 transition-transform" data-id="element-1342"></div>
              <img src="https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=sms:+17744727423" alt="SMS QR Code" className="rounded-lg shadow-md relative z-10" width={180} height={180} data-id="element-1343" />
              <p className="text-sm text-muted-foreground mt-2 relative z-10 text-center" data-id="element-1344">
                Scan to open SMS on your phone
              </p>
            </a>
            <a href={smsHref} className="w-full" data-id="element-1345">
              <Button size="lg" className="w-full group" data-id="element-1346">
                <MessageSquare size={16} className="mr-2 group-hover:animate-bounce" data-id="element-1347" />
                Text Now
              </Button>
            </a>
          </CardContent>
        </Card>
        <div className="space-y-6 mb-10 animate-fade-in" style={{
        animationDelay: '300ms'
      }} data-id="element-1348">
          <div className="text-left" data-id="element-1349">
            <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-1350">
              <Zap size={18} className="text-primary mr-2" data-id="element-1351" />
              How It Works
            </h3>
            <ol className="space-y-4" data-id="element-1352">
              <li className="flex items-start gap-3" data-id="element-1353">
                <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary flex-shrink-0 mt-0.5" data-id="element-1354">
                  1
                </div>
                <div data-id="element-1355">
                  <p className="font-medium" data-id="element-1356">Text any TikTok link</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1357">
                    Send a TikTok URL to {phoneNumber} to start.{' '}
                    <span className="text-primary font-medium" data-id="element-1358">
                      No account needed!
                    </span>
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-1359">
                <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary flex-shrink-0 mt-0.5" data-id="element-1360">
                  2
                </div>
                <div data-id="element-1361">
                  <p className="font-medium" data-id="element-1362">Get your transcript</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1363">
                    Readable content, instantly delivered
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-3" data-id="element-1364">
                <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center text-primary flex-shrink-0 mt-0.5" data-id="element-1365">
                  3
                </div>
                <div data-id="element-1366">
                  <p className="font-medium" data-id="element-1367">Remix and share</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1368">
                    Quote, tweet, blog, or save for later
                  </p>
                </div>
              </li>
            </ol>
          </div>
          {/* Phone-First Experience Section */}
          <div className="text-left" data-id="element-1369">
            <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-1370">
              <Smartphone size={18} className="text-primary mr-2" data-id="element-1371" />
              Phone-First Experience
            </h3>
            <div className="space-y-3" data-id="element-1372">
              <div className="flex items-start gap-2" data-id="element-1373">
                <History size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1374" />
                <div data-id="element-1375">
                  <p className="font-medium" data-id="element-1376">History Preserved</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1377">
                    All transcripts are saved under your phone number - even
                    before creating an account
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2" data-id="element-1378">
                <UserPlus size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1379" />
                <div data-id="element-1380">
                  <p className="font-medium" data-id="element-1381">Create Account When Ready</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1382">
                    Text <span className="font-medium" data-id="element-1383">/register</span> anytime
                    to create an account with all history intact
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2" data-id="element-1384">
                <ArrowUpRight size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1385" />
                <div data-id="element-1386">
                  <p className="font-medium" data-id="element-1387">Seamless Web Transition</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1388">
                    Switch between SMS and web without losing any data
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left" data-id="element-1389">
            <h3 className="text-lg font-medium mb-3 flex items-center" data-id="element-1390">
              <Sparkles size={18} className="text-primary mr-2" data-id="element-1391" />
              Magic Commands
            </h3>
            <div className="space-y-3" data-id="element-1392">
              <div className="flex items-start gap-2" data-id="element-1393">
                <FileText size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1394" />
                <div data-id="element-1395">
                  <p className="font-medium" data-id="element-1396">/vault</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1397">
                    Access your 5 most recent transcripts
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2" data-id="element-1398">
                <Brain size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1399" />
                <div data-id="element-1400">
                  <p className="font-medium" data-id="element-1401">/summary</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1402">
                    Get the key points in seconds - perfect for information
                    overload
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2" data-id="element-1403">
                <UserPlus size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1404" />
                <div data-id="element-1405">
                  <p className="font-medium" data-id="element-1406">/register</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1407">
                    Create an account that preserves all your transcript history
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2" data-id="element-1408">
                <Gift size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1409" />
                <div data-id="element-1410">
                  <p className="font-medium" data-id="element-1411">/referral</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1412">
                    Invite friends, both get 3 free credits
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-2" data-id="element-1413">
                <RefreshCw size={16} className="text-primary mt-1 flex-shrink-0" data-id="element-1414" />
                <div data-id="element-1415">
                  <p className="font-medium" data-id="element-1416">/help</p>
                  <p className="text-sm text-muted-foreground" data-id="element-1417">
                    Discover all available commands
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="text-left bg-secondary/30 p-4 rounded-lg border border-border" data-id="element-1418">
            <h3 className="text-lg font-medium mb-2 flex items-center" data-id="element-1419">
              <AlertCircle size={18} className="text-primary mr-2" data-id="element-1420" />
              SMS Consent
            </h3>
            <p className="text-sm text-muted-foreground" data-id="element-1421">
              By texting our number, you agree to receive automated reply
              messages. Standard message rates may apply. Reply STOP to opt out
              at any time.
              <Link to="/text/compliance" className="text-primary hover:underline ml-1" data-id="element-1422">
                View full terms
              </Link>
            </p>
          </div>
        </div>
        {/* User Journey Visualization */}
        <div className="mb-10 animate-fade-in" style={{
        animationDelay: '400ms'
      }} data-id="element-1423">
          <h3 className="text-lg font-medium mb-4" data-id="element-1424">Your Seamless Journey</h3>
          <div className="bg-secondary/30 rounded-lg p-4 border border-border" data-id="element-1425">
            <div className="flex flex-col space-y-4" data-id="element-1426">
              <div className="flex items-center" data-id="element-1427">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-1428">
                  <MessageSquare size={16} className="text-primary" data-id="element-1429" />
                </div>
                <div className="flex-1" data-id="element-1430">
                  <p className="font-medium" data-id="element-1431">First Text</p>
                  <p className="text-xs text-muted-foreground" data-id="element-1432">
                    Get instant value with no account
                  </p>
                </div>
              </div>
              <div className="w-0.5 h-4 bg-primary/30 ml-5" data-id="element-1433"></div>
              <div className="flex items-center" data-id="element-1434">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-1435">
                  <History size={16} className="text-primary" data-id="element-1436" />
                </div>
                <div className="flex-1" data-id="element-1437">
                  <p className="font-medium" data-id="element-1438">Build History</p>
                  <p className="text-xs text-muted-foreground" data-id="element-1439">
                    All transcripts saved to your phone number
                  </p>
                </div>
              </div>
              <div className="w-0.5 h-4 bg-primary/30 ml-5" data-id="element-1440"></div>
              <div className="flex items-center" data-id="element-1441">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-1442">
                  <UserPlus size={16} className="text-primary" data-id="element-1443" />
                </div>
                <div className="flex-1" data-id="element-1444">
                  <p className="font-medium" data-id="element-1445">Create Account (When Ready)</p>
                  <p className="text-xs text-muted-foreground" data-id="element-1446">
                    Text /register to preserve all history
                  </p>
                </div>
              </div>
              <div className="w-0.5 h-4 bg-primary/30 ml-5" data-id="element-1447"></div>
              <div className="flex items-center" data-id="element-1448">
                <div className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0 mr-3" data-id="element-1449">
                  <ArrowUpRight size={16} className="text-primary" data-id="element-1450" />
                </div>
                <div className="flex-1" data-id="element-1451">
                  <p className="font-medium" data-id="element-1452">Seamless Web Access</p>
                  <p className="text-xs text-muted-foreground" data-id="element-1453">
                    Switch between SMS and web anytime
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-border pt-6 animate-fade-in" style={{
        animationDelay: '400ms'
      }} data-id="element-1454">
          <div className="flex flex-col items-center mb-6" data-id="element-1455">
            <h3 className="text-lg font-medium mb-2" data-id="element-1456">Share the Magic</h3>
            <p className="text-sm text-muted-foreground mb-4" data-id="element-1457">
              Help your friends skip the endless scrolling 🧠✨
            </p>
            <div className="flex gap-3" data-id="element-1458">
              <Button variant="outline" onClick={handleShare} className="relative" data-id="element-1459">
                <Share2 size={16} className="mr-2" data-id="element-1460" />
                Share ScribeTok
                {shareOpen && <div className="absolute top-full mt-2 right-0 bg-card shadow-lg rounded-lg p-3 z-10 w-60 text-left" data-id="element-1461">
                    <Button variant="ghost" size="sm" className="w-full justify-start mb-2" onClick={handleCopyShareLink} data-id="element-1462">
                      <Copy size={14} className="mr-2" data-id="element-1463" />
                      Copy message
                    </Button>
                    <a href={`https://wa.me/?text=${encodeURIComponent(shareMessage)}`} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-1464">
                      <Button variant="ghost" size="sm" className="w-full justify-start mb-2" data-id="element-1465">
                        <span className="mr-2" data-id="element-1466">📱</span>
                        WhatsApp
                      </Button>
                    </a>
                    <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}`} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-1467">
                      <Button variant="ghost" size="sm" className="w-full justify-start" data-id="element-1468">
                        <span className="mr-2" data-id="element-1469">🐦</span>
                        Twitter
                      </Button>
                    </a>
                  </div>}
              </Button>
              <Link to="/features" data-id="element-1470">
                <Button variant="outline" data-id="element-1471">
                  Creator Features
                  <Star size={16} className="ml-2" data-id="element-1472" />
                </Button>
              </Link>
              <Link to="/app" data-id="element-1473">
                <Button variant="outline" data-id="element-1474">
                  Web App
                  <ArrowRight size={16} className="ml-2" data-id="element-1475" />
                </Button>
              </Link>
            </div>
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-muted-foreground text-sm mb-6" data-id="element-1476">
            <div className="flex items-center gap-2" data-id="element-1477">
              <CheckCircle size={14} className="text-success" data-id="element-1478" />
              <span data-id="element-1479">TikTok & YouTube Supported</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-1480">
              <CheckCircle size={14} className="text-success" data-id="element-1481" />
              <span data-id="element-1482">Free for Everyone</span>
            </div>
          </div>
          <p className="text-xs text-muted-foreground mb-2" data-id="element-1483">
            Your privacy, your words. ScribeTok never sells your data. 🔒
          </p>
          <p className="text-xs text-muted-foreground border-t border-border/50 pt-3 mt-3" data-id="element-1484">
            ScribeTok is a user-initiated SMS service. We do not send
            promotional messages. You can opt out at any time by replying STOP.
            Msg & data rates may apply.
          </p>
        </div>
        <div className="mt-12 max-w-lg mx-auto" data-id="element-1485">
          <h3 className="text-xl font-medium mb-4" data-id="element-1486">Example SMS Conversation</h3>
          <div className="bg-secondary/50 rounded-xl p-4 md:p-6 text-left" data-id="element-1487">
            <div className="space-y-4" data-id="element-1488">
              <div className="flex justify-end" data-id="element-1489">
                <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1490">
                  https://www.tiktok.com/@username/video/1234567890
                </div>
              </div>
              <div className="flex justify-start" data-id="element-1491">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1492">
                  <p className="flex items-start gap-2" data-id="element-1493">
                    <span className="text-xl" data-id="element-1494">🎬</span>
                    <span data-id="element-1495">
                      Thanks for using ScribeTok! You'll receive a transcript
                      shortly. Reply HELP for support or STOP to opt out.
                    </span>
                  </p>
                </div>
              </div>
              <div className="flex justify-start" data-id="element-1496">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1497">
                  <p className="flex items-start gap-2" data-id="element-1498">
                    <span className="text-xl" data-id="element-1499">⏳</span>
                    <span data-id="element-1500">Got your link! Transcribing now...</span>
                  </p>
                </div>
              </div>
              <div className="flex justify-start" data-id="element-1501">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm break-words" data-id="element-1502">
                  <p className="flex items-start gap-2" data-id="element-1503">
                    <span className="text-xl flex-shrink-0" data-id="element-1504">✅</span>
                    <span data-id="element-1505">Transcript ready!</span>
                  </p>
                  <p className="mt-2 ml-7" data-id="element-1506">
                    "Hey everyone, today I'm going to show you three
                    productivity hacks that changed my life..."
                  </p>
                  <p className="text-xs mt-2 text-primary font-medium ml-7" data-id="element-1507">
                    share.scribetok.com/v/b70c860b-d7dc-4570-ae26-1235c94ee654
                  </p>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-1508">
                <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1509">
                  /summary
                </div>
              </div>
              <div className="flex justify-start" data-id="element-1510">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1511">
                  <p className="flex items-start gap-2" data-id="element-1512">
                    <span className="text-xl" data-id="element-1513">📝</span>
                    <span className="font-medium" data-id="element-1514">Summary:</span>
                  </p>
                  <p className="mt-2 ml-7" data-id="element-1515">
                    Three productivity hacks: time blocking, two-minute rule for
                    small tasks, and digital detox every evening.
                  </p>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-1516">
                <div className="tiktok-gradient text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1517">
                  /register
                </div>
              </div>
              <div className="flex justify-start" data-id="element-1518">
                <div className="bg-gray-800 text-white px-4 py-3 rounded-2xl max-w-xs shadow-sm" data-id="element-1519">
                  <p className="flex items-start gap-2" data-id="element-1520">
                    <span className="text-xl" data-id="element-1521">👤</span>
                    <span className="font-medium" data-id="element-1522">
                      Let's create your account!
                    </span>
                  </p>
                  <p className="mt-2 ml-7" data-id="element-1523">
                    Enter your email to create an account and access all your
                    transcripts on the web.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}